<template>
  <div id="register">
    <div class="ContentContainer">
      <h3 class="heading-lined">{{ $t("register_page.register") }}</h3>
      <p v-html="$t('register_page.p_reg')"></p>
      <p>
        {{ $t("register_page.agree") }}
        <router-link to="/terms">{{ $t("register_page.terms") }}</router-link>
        {{ $t("register_page.and") }}
        <router-link to="/privacy">{{
          $t("register_page.privacy")
        }}</router-link
        >.
      </p>
      <!-- Validation errors -->
      <div v-if="$v.$invalid" class="alert alert-warning">
        <span v-if="!$v.email.required">{{
          $t("register_page.errors.email_required")
        }}</span>
        <span v-if="!$v.email.email">{{
          $t("register_page.errors.email_valid")
        }}</span>
        <span v-if="!$v.password.required">{{
          $t("register_page.errors.password_required")
        }}</span>
        <span v-if="!$v.password.minLength">
          {{
            $t("register_page.errors.password_length", {
              length: $v.password.$params.minLength.min,
            })
          }}
        </span>
        <span v-if="!$v.repeatPassword.sameAs">{{
          $t("register_page.errors.password_match")
        }}</span>
      </div>

      <div v-if="errorMessage" class="alert alert-danger">
        <span>{{ errorMessage }}</span>
      </div>

      <form @submit.prevent="registerWithEmail" class="form-group">
        <TextField
          ref="email"
          type="email"
          v-model="email"
          :placeholder="this.$t('register_page.placeholder.email')"
        />
        <TextField
          ref="password1"
          type="password"
          autocomplete="new-password"
          class="mt-2"
          v-model="password"
          :placeholder="this.$t('register_page.placeholder.password')"
        />
        <TextField
          ref="password2"
          type="password"
          autocomplete="new-password"
          class="mt-2"
          v-model="repeatPassword"
          :placeholder="this.$t('register_page.placeholder.password_repeat')"
        />
        <ButtonCointracker
          :disabled="$v.$invalid"
          class="btn-block mt-4"
          :text="this.$t('register_page.create_account')"
          type="submit"
        />
      </form>
    </div>
  </div>
</template>

<script>
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
import { mapActions } from "vuex";

import TextField from "../partials/TextField";
import ButtonCointracker from "../specials/ButtonCointracker";

export default {
  name: "Register",
  metaInfo: {
    title: "Register CoinTrackr", 
  },
  components: {
    TextField,
    ButtonCointracker,
  },
  data() {
    return {
      email: "",
      password: "",
      repeatPassword: "",
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
      minLength: minLength(8),
    },
    repeatPassword: {
      sameAs: sameAs("password"),
    },
  },
  computed: {
    errorMessage() {
      return this.$store.state.auth.errorMessage;
    },
  },
  methods: {
    registerWithEmail() {
      if (this.$v.$invalid) {
        return;
      }
      this.register({ email: this.email, password: this.password }).then(() =>
        this.$router.push("/")
      );
    },
    ...mapActions("auth", ["register"]),
  },
};
</script>
